import { render, staticRenderFns } from "./modularChild6.vue?vue&type=template&id=554e28dd&scoped=true"
import script from "./modularChild6.vue?vue&type=script&lang=js"
export * from "./modularChild6.vue?vue&type=script&lang=js"
import style0 from "./modularChild6.vue?vue&type=style&index=0&id=554e28dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e28dd",
  null
  
)

export default component.exports